import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { orgUnitsStoreStateSelector } from '~/selectors';

import { OrganizationUnit } from './types';

export type UseAllOrgUnitsOutput = {
  orgUnits: OrganizationUnit[];
  orgUnitsIncludeDeleted: OrganizationUnit[];
  orgUnitsPrimary: OrganizationUnit[];
  isLoading: boolean;
  failedToLoad: boolean;
  hasData: boolean;
  getUnitById: (unitId?: number) => OrganizationUnit | undefined;
  getUnitByIdIncludeDeleted: (unitId?: number) => OrganizationUnit | undefined;
};

export const useAllOrgUnits = (): UseAllOrgUnitsOutput => {
  const storeData = useSelector((state: StoreState) => {
    return orgUnitsStoreStateSelector(state);
  });

  const { orgUnits, orgUnitsIncludeDeleted } = storeData;

  const getUnitByIdFromArray = useCallback(
    (
      unitsList: OrganizationUnit[],
      unitId?: number,
    ): OrganizationUnit | undefined => {
      return unitsList.find((unit) => unit.fOrgUnitId === unitId);
    },
    [],
  );

  const getUnitById = useCallback(
    (unitId?: number): OrganizationUnit | undefined =>
      getUnitByIdFromArray(orgUnits, unitId),
    [getUnitByIdFromArray, orgUnits],
  );

  const getUnitByIdIncludeDeleted = useCallback(
    (unitId?: number): OrganizationUnit | undefined =>
      getUnitByIdFromArray(orgUnitsIncludeDeleted, unitId),
    [getUnitByIdFromArray, orgUnitsIncludeDeleted],
  );

  return {
    ...storeData,
    getUnitById,
    getUnitByIdIncludeDeleted,
  };
};
